export default function paramInit(rangePropJson, regexClass) {

  //サイトからの変数取得
  if (typeof paramKey === "undefined") return false;

  let params = (new URL(document.location)).searchParams;
  let entries = Object.entries(paramKey);


  let pramObj = {
    url: new URL(document.location),
    params: new URLSearchParams(new URL(document.location).search), // 既存の URLSearchParams インスタンスを使用
    jsonData: new Array(),
    allReset: function () {
      let modeValue = this.params.get("mode");
      this.params = new URLSearchParams();

      // 全角カンマと半角カンマを取り除く
      if (modeValue !== null) {
        modeValue = modeValue.replace(/(，|,)/g, '');
        this.params.set("mode", modeValue);
      }

      // URL パラメータが存在する場合に URL を更新
      if (this.params.toString() !== "") {
        this.url.search = decodeURIComponent(this.params.toString());
      } else {
        // パラメータが存在しない場合は `?` を取り除く
        this.url.search = "";
      }

      history.replaceState(null, null, this.url.href);

      // ここで this.params を再利用するために代入
      this.params = this.url.searchParams;
    },

    /**
     * 
     * @param {*} instance 
     * @returns 
     */
    add: function (instance) {


      let paramName, data, itemId;

      switch (instance.instanceType) {
        case "TabMenu":
          paramName = "mode";
          data = instance.mode;

          if (data === null || data !== "case") {
            this.params.delete(paramName);

          } else {

            if (this.params.has(paramName)) {
              this.params.set(paramName, instance.mode);
            } else {
              this.params.append(paramName, instance.mode);
            }
          }

          break;
        case "SearchClass":
          if (instance.propertyId === "ex_case") {
            itemId = instance.itemId;
            paramName = instance.propertyId;
          } else {
            itemId = instance.data.ItemId;
            paramName = getParamName(instance.data, entries);
          }

          if (this.params.has(paramName)) {

            let queryList = this.params.getAll(paramName);
            queryList = new Set(String.prototype.split.call(queryList, ','));
            queryList.add(itemId);
            this.params.set(paramName, [...queryList]);

          } else {
            this.params.append(paramName, itemId);
          }

          break;

        case "SliderClass":
          data = instance.data;
          paramName = getParamName(data, entries);
          const
            minParam = paramName[0],
            maxParam = paramName[1],
            minVal = removeComma(data.Val1),
            maxVal = removeComma(data.Val2);

          //パラメーターを全て持っている場合
          if (minVal != null & maxVal != null) {
            if (paramName.every(v => this.params.has(v))) {
              this.params.set(minParam, minVal);
              this.params.set(maxParam, maxVal);
            } else {
              this.params.append(minParam, minVal);
              this.params.append(maxParam, maxVal);
            }
          }
          break;

        case "TextSearchClass":
          data = instance.data[0].data;
          paramName = getParamName(data, entries);
          if (this.params.has(paramName)) {
            this.params.set(paramName, instance.keyWord)
          } else {
            this.params.append(paramName, instance.keyWord);
          }

          break;
        case "CaseSearchClass":
          data = instance.keyWord;
          paramName = "casesearch";


          if (this.params.has(paramName)) {
            this.params.set(paramName, data);
          } else {
            this.params.append(paramName, data);
          }

          break;
        case "CaseSearchValue":
          data = instance.data.Text;
          paramName = "casesearch";

          if (this.params.has(paramName)) {
            let queryList = this.params.getAll(paramName);
            queryList.push(data);
            this.params.set(paramName, queryList);

          } else {
            this.params.append(paramName, data);
          }

          break;
      }

      const url = (this.params && this.params.toString() !== "") ? "?" + this.params.toString() : "";

      history.replaceState(null, null, url);
      if (this.checkParamsAndKeys().hasParams === false) {
        this.removeQuestionMarkFromUrl();
      }
    },
    remove: function (instance) {
      console.log("paramHandler: remove");
      console.log( instance );

      let paramName, data, itemId;

      switch (instance.instanceType) {
        case "TabMenu":
          paramName = "mode";

          if (this.params.has(paramName)) {
            this.params.set(paramName, instance.mode);
          } else {
            this.params.append(paramName, instance.mode);
          }

          break;
        case "SearchClass":

          if (instance.propertyId === "ex_case") {
            itemId = instance.itemId;
            paramName = instance.propertyId;
          } else {
            itemId = instance.data.ItemId;
            paramName = getParamName(instance.data, entries);
          }

          if (this.params.has(paramName)) {

            let queryList = this.params.getAll(paramName);
            queryList = new Set(String.prototype.split.call(queryList, ','));
            queryList.delete(itemId);
            this.params.set(paramName, [...queryList]);

            if (queryList.size < 1) {
              this.params.delete(paramName);
            } else {
              this.params.set(paramName, [...queryList]);
            }

          } else {
            this.params.append(paramName, itemId);
          }

          break;
        case "SliderClass":
          console.log(this.params );
          console.log("SliderClass");
          data = instance.data;
          paramName = getParamName(data, entries);
          const minParam = paramName[0];
          const maxParam = paramName[1];
          
          console.log("---------------------this.params--------------------");
          console.log(this.params);
          console.log(this.params.keys());
          console.log(this.params.values());

          console.log("---------------------keys--------------------");
          const paramKeys = params.keys();
          for (const key of paramKeys) {
              console.log(key);
          }
        
          console.log("---------------------this.params--------------------");
          console.log( this.params.has("min-density"));
          console.log( this.params.has("max-density"));
          console.log(this.params.getAll("min-density"));
          console.log(this.params.getAll("max-density"));
          // console.log( this.params.delete("min-density"));
          // console.log( this.params.delete("max-density"));
          console.log("---------------------this.params--------------------");
          console.log( this.params.has("min-density"));
          console.log( this.params.has("max-density"));
          this.params.delete(minParam);
          this.params.delete(maxParam);
          this.removeParams([minParam, maxParam]);
        
          break;

        case "TextSearchClass":

          data = instance.data[0].data;
          paramName = getParamName(data, entries);

          this.params.delete(paramName);

          break;

        case "CaseSearchValue":

          let itemText;
          
          itemText = instance.data.Text;
          paramName = instance.data.PropertyId;


          if (this.params.has(paramName)) {

            let queryList = this.params.getAll(paramName);
            queryList = new Set(String.prototype.split.call(queryList, ','));
            queryList.delete(itemText);
            this.params.set(paramName, [...queryList]);

            if (queryList.size < 1) {
              this.params.delete(paramName);
            } else {
              this.params.set(paramName, [...queryList]);
            }

          } else {
            this.params.append(paramName, itemId);
          }


          break;

      }
      const url = (this.params !== null) ? "?" + this.params.toString() : "";
      history.replaceState(null, null, url);
      
      if (this.checkParamsAndKeys().hasParams === false) {
        this.removeQuestionMarkFromUrl();
      }
    },
    hasKey: function (key) {
      return this.params.has(key);
    },

    hasKeyValue: function (key, value) {
      return this.params.get(key) === value;
    },
    getValue: function (key) {
      return this.params.get(key);
    },

    checkParamsAndKeys: function () {
      // URL パラメータのキーのリストを取得
      const paramKeys = Array.from(this.params.keys());

      // パラメータが存在しない場合は false を返す
      if (paramKeys.length === 0) {
        return {
          hasParams: false,
          hasKeys: false,
        };
      }

      // パラメータとキーの存在を確認
      return {
        hasParams: true,
        hasKeys: entries.some(([key]) => paramKeys.includes(key)),
      };
    },
    
    removeParams: function(keysToRemove) {
      // keysToRemoveに含まれるキーを削除する
      for (const key of keysToRemove) {
        this.params.delete(key);
      }

      // URL を更新する
      this.url.search = this.params.toString() !== '' ? `?${this.params.toString()}` : '';
      history.replaceState(null, null, this.url.href);
    },

    removeQuestionMarkFromUrl: function () {
      // URL の末尾が "?" で終わっている場合、それを取り除いて新しい URL を返す
      let urlWithoutQuestionMark = this.url.href.replace(/\?$/, '');
      this.url = new URL(urlWithoutQuestionMark);

      // ここで this.url を再利用するために代入
      this.params = this.url.searchParams;

      // 新しい URL オブジェクトを作成して代入
      this.url = new URL(this.url.href);
      history.replaceState(null, null, this.url.href); // URL を更新する
    }

  }

  function removeComma(num) {
    if (typeof num !== "string") return false;
    let removed = num.replace(/,/g, '');
    return parseFloat(removed, 10);
  }


  function getParamName(data, jsonArg) {

    let id = data.PropertyId;

    let target = jsonArg.filter(v => v[0] == id)[0];
    return target[1].ParamName;
  }

  function getProp(paramId, jsonArg) {
    //ex_case　はapiにないため、ex_caseを返す。
    if (paramId === "ex_case") return "ex_case";
    return jsonArg.filter(v => v.PropertyId == paramId);
  }

  function sanitize(str) {
    return String(str).replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  let jsonData = new Array();


  for (var pair of params.entries()) {

    if (pair[0] && pair[1]) {
      let findParam = [...entries].filter(v => {
        if (typeof v["1"].ParamName === "object" && v["1"].ParamName.length > 0) {
          //ネームparamが配列で複数存在する時
          const paramArr = v["1"].ParamName;
          return paramArr.some(v2 => v2 === pair[0]);
        } else {
          return (v["1"].ParamName == pair[0]);
        }
      })[0];


      if (findParam) {
        const
          paramId = findParam[0],
          paramQuery = pair[0];


        const prop = getProp(paramId, rangePropJson);
        let values = sanitize(pair[1]).split(',');
        let jsonObj = makeJson(prop, findParam, values, paramQuery);

        if (jsonObj !== undefined) {
          jsonData = jsonMerge(jsonData, jsonObj);
          pramObj.jsonData = jsonMerge(pramObj.jsonData, jsonObj);
        };

      }
    }
  }

  function jsonMerge(jsonData, jsonObj) {

    let index = jsonData.findIndex(v => v.PropertyId === jsonObj.PropertyId);
    if (index < 0 || jsonObj.PropertyId === 30260) {
      jsonData.push(jsonObj);
    } else {

      for (var item in jsonObj) {
        let samePropCheck = jsonData[index].hasOwnProperty(item);
        if (samePropCheck === false) {
          //レンジの異なるメンバを持つときに値を追加
          jsonData[index][item] = jsonObj[item];
        } else {
          //レンジの同一メンバで異なる値が追加で指定されていた場合
          if (jsonData[index][item] !== jsonObj[item]) {
            jsonData[index][item] = jsonObj[item];
          };
        }

      }

    }
    return jsonData;


  }

  function getRange(str) {
    const minPattern = new RegExp(/^min-.+/);
    const maxPattern = new RegExp(/^max-.+/);
    if (str.match(minPattern)) {
      return "min";
    } else if (str.match(maxPattern)) {
      return "max";
    } else {
      return false;
    }
  }

  function makeJson(prop, paramData, value, paramWord) {

    let id, unitId, type, andsearch, paramQuery;

    if (paramWord !== "ex_case") {
      id = prop[0].PropertyId;
      unitId = prop[0].UnitId;
      type = prop[0].PropertyType;
      andsearch = paramData[1].AndSearch || null;
      paramQuery = paramWord;
    } else {
      id = prop;
      type = "List";
      unitId = null;
      andsearch = paramData[1].AndSearch || null;
      paramQuery = paramWord;
    }

    switch (type) {
      case "List":
      case "ex_case":
        return makeItemProp(id, type, andsearch, unitId, value);
      case "Text":
        return makeTextProp(id, type, value);
      case "NumericRange":
      case "Numeric":
        const range = getRange(paramQuery);
        return makeNumericProp(id, type, unitId, value, range);
      default:
        // 未知のタイプの場合にどのように処理するかを決めてください
        console.error("未知のタイプ: " + type);
        return null; // または適切なデフォルト値を返す
    }
  }


  function makeItemProp(id, type, andsearch, unitId, value) {
    let numReg = /\d+/g;
    let obj;
    let checkValue = value.some(v => numReg.test(v));
    if (checkValue) {
      obj = {
        PropertyId: id,
        Type: type,
        UnitId: unitId,
        ItemIds: value
      };
      if (andsearch !== null) {
        obj.AndSearch = andsearch;
      }
      return obj;
    }
  }

  function makeTextProp(id, type, value) {
    let obj;
    obj = {
      PropertyId: id,
      Type: type,
      Text: value
    };
    return obj;
  }


  function makeNumericProp(id, type, unitId, value, range) {
    let numReg = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g;
    let obj;
    let checkValue = value.every(v => numReg.test(v));
    let num = parseFloat(value["0"]);
    if (checkValue) {
      obj = {
        PropertyId: id,
        Type: type,
        UnitId: unitId,
      };
      if (range === "max") {
        obj.Val2 = num;
      } else if (range === "min") {
        obj.Val1 = num;
      }
      return obj;
    }
  }


  

  return pramObj;


}